import { useEffect } from "react";
import { makeStyles } from "tss-react/mui";
import { MiPrintTable } from "@miplatform/assets";
import { MiBoxSelector, MiModal } from "@miplatform/components";
import {
  BUTTON_COLORS,
  BUTTON_VARIANTS,
  PRINT_ORIENTATION,
} from "@miplatform/constants";
import { CalendarEventType, CalendarType } from "@miplatform/types";
import { mdiPrinterOutline } from "@mdi/js";
import { usePrint, useSession, useSubscriptions } from "@mibuildweb/hooks";
import { Box, Typography } from "@mui/material";
import { HOLDS_COLUMNS_PRINT } from "./HoldsPrintModal.constants";
import { useHoldsPrintModalViewModel } from "./useHoldsPrintModalViewModel";

export interface HoldsPrintModalProps {
  open: boolean;
  calendarId: string;
  templatesIds: string[];
  eventType: CalendarEventType;
  calendarType: CalendarType;
  onClose: () => void;
}

export const HoldsPrintModal = ({
  open,
  onClose,
  calendarId,
  templatesIds,
  eventType,
  calendarType,
}: HoldsPrintModalProps) => {
  const {
    session: { tenantId },
  } = useSession();
  const { classes } = useStyles();
  const {
    subscriptionDetails,
    isLoading: isSubscriptionLoading,
    getSubscriptionDetails,
  } = useSubscriptions();
  const { handlePrintTable } = usePrint(subscriptionDetails);
  const { isLoading, getAttempts } = useHoldsPrintModalViewModel({
    calendarId,
    templateIds: templatesIds,
    eventType,
    calendarType,
  });

  const handlePrint = async () => {
    const attempts = await getAttempts();

    handlePrintTable(attempts, HOLDS_COLUMNS_PRINT, {
      orientation: PRINT_ORIENTATION.LANDSCAPE,
    });

    onClose();
  };

  useEffect(() => {
    getSubscriptionDetails(tenantId as string);
  }, [tenantId]);

  return (
    <MiModal
      open={open}
      closeModal={onClose}
      title="Print Holds"
      width={300}
      titleIcon={mdiPrinterOutline}
      actions={[
        {
          name: "Cancel",
          variant: BUTTON_VARIANTS.TEXT,
          color: BUTTON_COLORS.BLACK,
          size: "medium",
          onClick: onClose,
        },
        {
          name: "Print",
          variant: BUTTON_VARIANTS.CONTAINED,
          size: "medium",
          color: BUTTON_COLORS.PRIMARY,
          onClick: handlePrint,
          disabled: isLoading || isSubscriptionLoading,
        },
      ]}
      loading={isLoading || isSubscriptionLoading}
    >
      <Typography className={classes.title}>Print Type</Typography>
      <Box className={classes.selectorsContainer}>
        <MiBoxSelector
          selected
          label="Table List View"
          icon={<img src={MiPrintTable} alt="Print table" />}
          onChange={() => {}}
          description=""
          width="100%"
          variant="none"
          size="big"
          disabled={false}
        />
      </Box>
    </MiModal>
  );
};

const useStyles = makeStyles()((theme) => ({
  title: {
    fontSize: theme.fontSize.medium,
    fontWeight: 600,
    paddingBottom: theme.spacing(1),
  },
  selectorsContainer: {
    display: "flex",
    flexDirection: "row",
    flex: 1,
    gap: theme.spacing(2),
  },
}));
